import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { EdpWidgetConsumptionsVoiceReadingComponent } from "./edp-widget-consumptions-voice-reading.component";
import { ScrollListItemModule } from "@edp-directives/scroll-list-item/scroll-list-item.module";

@NgModule({
    declarations: [EdpWidgetConsumptionsVoiceReadingComponent],
    imports: [CommonModule, TranslateModule, ScrollListItemModule],
    exports: [EdpWidgetConsumptionsVoiceReadingComponent],
})
export class EdpWidgetConsumptionsVoiceReadingModule {}
